export const DEFAULT_ROUTES = {
  INDEX: "/",
  SIGNIN: "/signin",
  PRIVATE_OFFICE_BOOKINGS: "/private-office/bookings",
  PRIVATE_OFFICE_BOOKING_CREATE: "/private-office/bookings/create",
  PRIVATE_OFFICE_BOOKING_DOWNSELL:
    "/private-office/bookings/downsell/:bookingId",
  LICENSE_FEE_LIST: "/contracts/license-fee/list",
  LICENSE_FEE_CREATE: "/contracts/license-fee/create",
  PO_AGENT: "/po-agent",
  LICENSE_FEE_UPDATE: "/contracts/license-fee/edit/:licenseFeeId",
  VISION_360: "/vision",
  VISION_360_BETA_SETUP: "/vision/setup",
  VISION_360_BETA_CURATION: "/vision/curation",
  VISION_360_BETA_LONG_LIST: "/vision/long-list",
  VISION_360_BETA_SHORT_LIST: "/vision/short-list",
  VISION_360_AI_MODE: "/vision/ai",
  VISION_360_PROPOSAL: "/vision/proposta/:uuid",
  VISION_360_PROPOSAL_SMB: "/vision/proposta-smb/:uuid",
  VISION_360_PROPOSALS: "/vision/proposals",
  VISION_PROPOSAL_DETAIL: "/vision/proposals/:uuid",
  PARTNER_DEMO: "/vision/partner-demo",
  PRIVATE_OFFICE_CONTRACTS_LIST: "/private-office/contracts/list",
  PRIVATE_OFFICE_CONTRACTS_CREATE: "/private-office/contracts/create",
  PRIVATE_OFFICE_ADMIN: "/private-office/admin",
  PRIVATE_OFFICE_ADMIN_DETAILS: "/private-office/admin/:roomId/details",
  PRIVATE_OFFICE_CONTRACTS_UPDATE:
    "/private-office/contracts/update/:contractId",
  PRIVATE_OFFICE_CONTRACTS_CANCEL:
    "/private-office/contracts/cancel/:contractId",
  PRIVATE_OFFICE_UPDATE_REQUESTS: "/private-office/update-requests",
  PRIVATE_OFFICE_UPDATE_REQUESTS_REJECT: "reject/:requestId",
  PRIVATE_OFFICE_NEW_CREATE: "/private-office/new-create",
  PRIVATE_OFFICE_NEW_EDIT: "/private-office/edit/:privateOfficeId",
  PRIVATE_OFFICE_NEW_CREATE_EXTERNAL: "/private-office/external/new-create",
  PRIVATE_OFFICE_NEW_EDIT_EXTERNAL:
    "/private-office/external/edit/:privateOfficeId",
  PRIVATE_OFFICE_NEW_UNAUTHORIZED: "/private-office/external/unauthorized",
  ATLAS: "/atlas",
};

export const PUBLIC_ROUTES = ["/vision/proposta", "/vision/proposta-smb"];

export const isPublicRoute = (pathname: string): boolean => {
  return PUBLIC_ROUTES.some((route) => pathname.startsWith(route));
};

export type ROUTE =
  | "INDEX"
  | "SIGNIN"
  | "PRIVATE_OFFICE_BOOKINGS"
  | "PRIVATE_OFFICE_BOOKING_CREATE"
  | "PRIVATE_OFFICE_BOOKING_DOWNSELL"
  | "LICENSE_FEE_LIST"
  | "LICENSE_FEE_CREATE"
  | "LICENSE_FEE_UPDATE"
  | "VISION_360"
  | "VISION_360_BETA"
  | "VISION_360_BETA_SETUP"
  | "VISION_360_BETA_CURATION"
  | "VISION_360_BETA_LONG_LIST"
  | "VISION_360_BETA_SHORT_LIST"
  | "PRIVATE_OFFICE_CONTRACTS_LIST"
  | "PRIVATE_OFFICE_CONTRACTS_CREATE"
  | "PRIVATE_OFFICE_ADMIN"
  | "PRIVATE_OFFICE_CONTRACTS_UPDATE"
  | "PRIVATE_OFFICE_CONTRACTS_CANCEL"
  | "PRIVATE_OFFICE_UPDATE_REQUESTS"
  | "PRIVATE_OFFICE_UPDATE_REQUESTS_REJECT"
  | "PRIVATE_OFFICE_NEW_CREATE"
  | "PRIVATE_OFFICE_NEW_EDIT"
  | "PRIVATE_OFFICE_NEW_CREATE_EXTERNAL"
  | "PRIVATE_OFFICE_NEW_EDIT_EXTERNAL";

/**
 * Hook to get the private office create route
 * @param isExternal - Whether this is for external (non-authenticated) route
 * @returns The route path to use
 */
export const usePrivateOfficeCreateRoute = (isExternal = false): string => {
  return isExternal
    ? DEFAULT_ROUTES.PRIVATE_OFFICE_NEW_CREATE_EXTERNAL
    : DEFAULT_ROUTES.PRIVATE_OFFICE_NEW_CREATE;
};

/**
 * Hook to get the private office edit/update route
 * @param privateOfficeId - The ID of the private office to edit
 * @param isExternal - Whether this is for external (non-authenticated) route
 * @returns The route path to use (with ID parameter replaced if provided)
 */
export const usePrivateOfficeEditRoute = (
  privateOfficeId?: string,
  isExternal = false,
): string => {
  const route = isExternal
    ? DEFAULT_ROUTES.PRIVATE_OFFICE_NEW_EDIT_EXTERNAL
    : DEFAULT_ROUTES.PRIVATE_OFFICE_NEW_EDIT;

  // Replace the parameter with actual ID if provided
  if (privateOfficeId) {
    return route.replace(":privateOfficeId", privateOfficeId);
  }

  return route;
};
